import React, { Component } from "react";
import { Link } from "gatsby";
import Layout from "./layout";
import "../css/style.css"

class Coursedetail extends Component {
  
render(){
  return(

    <div class="online-journey-inner">
        <div class="row align-items-center"> 
            <div class="col-md-6">
                <div class="text-box wow fadeInLeft pl-0" data-wow-duration="1s" data-wow-delay=".2s">
                    <h3 className="text-center text-md-left">Admissions information</h3> 
                      <ul className="mt-3 mt-md-5 mb-2">
                        <li>
                            <h4>Academic qualifications</h4>
                            <span>{this.props.QualificationInfo}</span>
                        </li>
                        <li>
                            <h4>english requirements</h4>
                            <span>{this.props.EnglishRequirments}</span>
                        </li>
                        <li>
                            <h4>other requirements</h4>
                            <span>{this.props.OtherRequirments}</span>
                        </li>
                        <li>
                            <h4>fees and scholarships</h4>
                            <span>
                                Yr 1: Online fees:  {this.props.OnlineFees}
                            </span>
                            <span>
                                Yr 1: On - campus fees:{this.props.CampusFees}
                            </span>
                        </li>
                    </ul> 
                      {/* <div className="col-12"> */}
                          {/* <Link
                              to="#"
                              class="btn-default wow fadeInUp mb-3 mb-md-0 mx-auto mx-md-0"
                              data-wow-duration="1s"
                              data-wow-delay=".1s"
                          >
                              Speak To An Expert
                          </Link> */}
                      {/* </div> */}
                </div>
            </div>
            <div class="col-md-6">
                <div class="image-holder wow fadeInRight" data-wow-duration="1s" data-wow-delay=".1s">
                    <img src="https://media.publit.io/file/TheWorldgrad/2Programdetailedpage/pexels-kelly-lacy-2928232-min_znehfb.jpg" alt="" class="img-fluid" />
                </div>
            </div>
        </div> 
    </div>
  )
}

}

export default Coursedetail;